import { render, staticRenderFns } from "./starMember.vue?vue&type=template&id=05ffc551&scoped=true"
import script from "./starMember.vue?vue&type=script&lang=js"
export * from "./starMember.vue?vue&type=script&lang=js"
import style0 from "./starMember.vue?vue&type=style&index=0&id=05ffc551&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ffc551",
  null
  
)

export default component.exports